function scaled(singular, plural) {
  return {
    singular,
    plural,
  }
}

export default {
  useLongScale: false,
  baseSeparator: " ",
  unitSeparator: "",
  base: {
    "0": "null",
    "1": "üks",
    "2": "kaks",
    "3": "kolm",
    "4": "neli",
    "5": "viis",
    "6": "kuus",
    "7": "seitse",
    "8": "kaheksa",
    "9": "üheksa",
    "10": "kümme",
    "11": "üksteist",
    "12": "kaksteist",
    "13": "kolmteist",
    "14": "neliteist",
    "15": "viisteist",
    "16": "kuusteist",
    "17": "seitseteist",
    "18": "kaheksateist",
    "19": "üheksateist",
    "20": "kakskümmend",
    "30": "kolmkümmend",
    "40": "nelikümmend",
    "50": "viiskümmend",
    "60": "kuuskümmend",
    "70": "seitsekümmend",
    "80": "kaheksakümmend",
    "90": "üheksakümmend",
    "100": "sada",
    "200": "kakssada",
    "300": "kolmsada",
    "400": "nelisada",
    "500": "viissada",
    "600": "kuussada",
    "700": "seitsesada",
    "800": "kaheksasada",
    "900": "üheksasada",
  },
  units: [
    {
      useBaseInstead: true,
      useBaseException: [],
    },
    scaled("tuhat", "tuhat"),
    scaled("miljon", "miljonit"),
    scaled("miljard", "miljardit"),
    scaled("triljon", "triljonit"),
    scaled("kvadriljon", "kvadriljonit"),
    scaled("kvintiljon", "kvintiljonit"),
    scaled("sekstiljon", "sekstiljonit"),
    scaled("septiljon", "septiljonit"),
    scaled("oktiljon", "oktiljonit"),
    scaled("noniljon", "noniljonit"),
    scaled("detsiljon", "detsiljonit"),
    scaled("undetsiljon", "undetsiljonit"),
    scaled("duodetsiljon", "duodetsiljonit"),
    scaled("tredetsiljon", "tredetsiljonit"),
    scaled("kvatuordetsiljon", "kvatuordetsiljonit"),
    scaled("kvintdetsiljon", "kvintdetsiljonit"),
  ],
  unitExceptions: [],
  currencies: {
    EUR: {
      singular: "euro",
      plural: "eurot",
      cents: "senti",
    },
  },
}
